import { TempFileServiceError } from "./TempFileServiceError";

export class FailedToUploadImage extends TempFileServiceError {}